<template>
  <div
    class="icon-button d-inline-block"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    :style="!hover ? 'opacity: .5;' : ''"
    @click.stop="$emit('click')"
  >
    <b-icon :icon="icon" :class="$slots.default && $slots.default.length ? 'mr-1' : ''"></b-icon>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
  },
  data: () => ({
    hover: false
  })
}
</script>

<style>
  .icon-button {
    transition: opacity .25s ease-in-out;
  }
</style>